import { stringify } from 'yaml';

const toYaml = (value) => stringify(value);

export { toYaml };
